export default __webpack_public_path__ + "static/media/codelockr@2x.fb8df882.png";